import LiveOrdersScreen from './LiveOrdersScreen';
import { LiveOrdersContext } from '~/mobx/ordersStore/context';
import { liveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';

export default function (props: any) {
  return (
    <LiveOrdersContext.Provider value={{ store: liveOrdersStore }}>
      <LiveOrdersScreen {...props} />
    </LiveOrdersContext.Provider>
  );
}
